import { competitionListTimeEnum } from "app/utils/const";
import { Component } from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import { injectIntl, IntlShape } from "react-intl";
import { connect } from "react-redux";
import { getDatesWithEvents } from "../../../../../../api/competitionsApi";
import { GetDatesHelper } from "../../helpers/GetDatesHelper/GetDatesHelper";
type Props = {
  selectedSportTimeFrame: string;
  selectedDate: string;
  intl: IntlShape;
  selectedCompetitionIds: number[];
  defaultId: number;
  sportNavNodeId: number;
  setFilter: (payload: { [key: string]: boolean | string | null }) => void;
  setFilters: (payload: { [key: string]: boolean | string | null }[]) => void;
};
type State = {
  initialised: boolean;
  datesWithEvents: Record<string, any>[];
  disablePreGameFilter: boolean;
};

class DatesFilter extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      disablePreGameFilter: false,
      datesWithEvents: [],
      initialised: false,
    };
  }

  selectDate(date: Record<string, any>) {
    this.props.setFilter({ selectedDate: date.value });
  }

  getListOfDatesWithEvents() {
    // List of dates depends on what sport or competitions have been selected
    // so check for selectedCompetitionIds, if not set then use sportNavNodeId, if sportNavNodeId not available use the default
    const { selectedCompetitionIds, defaultId, sportNavNodeId } = this.props;
    let navNodeIds: any | Object = [];

    if (selectedCompetitionIds && selectedCompetitionIds.length > 0) {
      navNodeIds = selectedCompetitionIds;
    } else if (sportNavNodeId) {
      navNodeIds.push(sportNavNodeId);
    } else {
      navNodeIds.push(defaultId);
    }

    getDatesWithEvents(navNodeIds).then(response => {
      // When initialised is false, set selectedDate to the first date on the list returned by api
      // initialised will be false for the first load, and when sport or selectedCompetitionIds change
      if (!this.state.initialised) {
        if (response.days && response.days.length > 0) {
          this.props.setFilter({ selectedDate: response.days[0].day });
        } else {
          this.props.setFilter({ selectedDate: "ALL" });
        }
      }

      this.setState(() => {
        return {
          datesWithEvents: response.days,
          initialised: true,
        };
      });
    });
  }

  componentDidUpdate = (
    prevProps: Record<string, any>,
    prevState: Record<string, any>
  ) => {
    if (
      this.haveNavigationIdsChanged(
        prevProps.selectedCompetitionIds,
        this.props.selectedCompetitionIds
      ) ||
      prevProps.sportNavNodeId !== this.props.sportNavNodeId
    ) {
      this.getListOfDatesWithEvents();
    }
  };
  componentDidMount = () => {
    // drop loads blank unless this is called
    this.getListOfDatesWithEvents();
  };

  haveNavigationIdsChanged = (arr1: number[], arr2: number[]): boolean => {
    // Check if either array is null or undefined
    // If different it means one has changed so fetch new dates
    if (!arr1 || !arr2) {
      return !!arr1 !== !!arr2;
    }
    if (arr1?.length !== arr2?.length) {
      return true;
    }
    return !arr1.every(item => arr2.includes(item));
  };

  render() {
    const { selectedSportTimeFrame, intl, selectedDate } = this.props;
    const { datesWithEvents } = this.state;
    let disableDatesFilter, hasDate, dates;
    if (selectedSportTimeFrame === competitionListTimeEnum.EARLY) {
      // if dates has just one element it means that there are no dates available, only ALL Dates,
      dates = GetDatesHelper.getDates(datesWithEvents, intl);
      // so disable the dropdown
      disableDatesFilter = dates && dates.length < 2;
      // To handle edge case where the selectedDate is not in the list of dates.
      // if hasDate is undefined, show "All Dates"
      hasDate = dates.find(date => {
        return date.value === this.props.selectedDate;
      });
    }

    const dropdownValue = hasDate
      ? selectedDate
      : {
          value: "ALL",
          label: intl.formatMessage({
            id: "global-events-navigation-all-dates",
          }),
        };
    return (
      <div
        className={
          disableDatesFilter
            ? "global-event-navigation__dates--disabled"
            : "global-event-navigation--pre-game-only"
        }
      >
        <Dropdown
          id="dates"
          name="dates"
          options={
            selectedSportTimeFrame === competitionListTimeEnum.EARLY && dates
          }
          className="navigation-sorting__dropdown"
          onChange={e => this.selectDate(e)}
          disabled={disableDatesFilter}
          value={dropdownValue}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedDate: state.asianCompetitionListFiltersModel.selectedDate,
  defaultId: state.sportsSelectionListModel.defaultId,
  sportNavNodeId: state.sportsSelectionListModel.sportNavNodeId,
  selectedSportTimeFrame: state.sportsSelectionListModel.selectedSportTimeFrame,
  selectedCompetitionIds:
    state.asianCompetitionListFiltersModel.selectedCompetitionIds,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    loadCurrentBetsCount: () =>
      dispatch.betSlipListModel.loadCurrentBetsCount(),
    loadUser: () => dispatch.userModel.loadUser(),
    setFilter: (payload: { [key: string]: boolean | string }) => {
      dispatch.asianCompetitionListFiltersModel.setFilter(payload);
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(DatesFilter)) as any;
